import { useEffect, useState } from 'react';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { ApproveButton, CancelButton, SaveButton } from '../../../components/mui/Buttons/Buttons';
import { Alert, Box, Button, TextField } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import dayjs from 'dayjs';
import { addExpectedSessions, getFeeForecastData } from '../../../redux/features/feeForecastSlice';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';

const AddExpectedSessions = ({
  date,
  enrollId,
  isCalendar = false,
  finalSessions,
  isDisabled = false,
  dispatchParams,
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [sessions, setSessions] = useState('');
  const [verification, setVerification] = useState({
    verification_required: false,
    messg: '',
  });
  const handleApiResponse = useHandleApiResponse();
  const { loading } = useSelector((state) => state.feeForecast);

  const handleSubmit = (status) => {
    if (!sessions && !isCalendar) {
      return enqueueSnackbar('Please enter expected sessions', {
        variant: 'error',
      });
    }
    const data = {
      year: dayjs(date).format('YYYY'),
      month: dayjs(date).format('MM'),
      courseEnrollmentId: enrollId,
      expectedSessions: isCalendar ? null : sessions,
      verify: status,
      fromCalendar: isCalendar ? true : false,
      isConfirm: verification.verification_required,
    };
    console.log(data);

    dispatch(addExpectedSessions(data)).then((res) => {
      if (res.payload.status == 'confirm_required') {
        setVerification({ verification_required: true, messg: res.payload.message });
      } else {
        handleApiResponse(res, {
          onSuccess: () => {
            setVerification({ verification_required: false, messg: '' });
            setOpen(false);
            dispatch(getFeeForecastData(dispatchParams));
          },
          onFailed: () => {
            console.log('Something went wrong');
          },
        });
      }
    });
  };

  useEffect(() => {
    if (!isCalendar && finalSessions) {
      setSessions(finalSessions);
    }
  }, [finalSessions, isCalendar]);
  return (
    <GlobalDialog
      title={isCalendar ? 'Verify Expected Sessions ' : 'Add Expected Sessions'}
      open={open}
      setOpen={setOpen}
      maxWidth={'xs'}
      fullWidth
      closeButton={true}
      popupButton={
        <Button
          variant="contained"
          color={isCalendar ? 'success' : 'warning'}
          sx={{ height: 15, fontSize: 10 }}
          onClick={() => setOpen(true)}
          disabled={isDisabled}
        >
          {isCalendar
            ? 'Verify expected sessions'
            : !isCalendar && finalSessions
              ? 'Update expected sessions'
              : 'Add expected sessions'}
        </Button>
      }
      content={
        <>
          <Box sx={{ p: 1 }}>
            {isCalendar ? null : (
              <TextField
                label="Expected Sessions"
                placeholder="Enter expected sessions"
                size="small"
                fullWidth
                type="number"
                value={sessions}
                onChange={(e) => setSessions(e.target.value)}
              />
            )}

            <Box mt={1}>
              <Alert severity="warning">Once verified & saved, this record cannot be edited.</Alert>
            </Box>
            {verification?.verification_required ? (
              <Box mt={1}>
                <Alert severity="error">{verification?.messg}</Alert>
              </Box>
            ) : null}
          </Box>
        </>
      }
      actionButton={
        <>
          <CancelButton size={'small'} action={() => setOpen(false)} />
          {/* {isCalendar ? null : (
            <SaveButton disabled={loading} size={'small'} action={() => handleSubmit(false)}>
              {loading ? 'Saving...' : 'Save'}
            </SaveButton>
          )} */}

          <ApproveButton size={'small'} action={() => handleSubmit(true)}>
            {' '}
            {loading ? 'Saving...' : 'Save'}
          </ApproveButton>
        </>
      }
    />
  );
};

export default AddExpectedSessions;
